<template>
    <svg xmlns="http://www.w3.org/2000/svg"
        fill="none" 
        viewBox="0 0 24 24" 
        :stroke-width="strokeWidth" 
        :stroke="strokeColor" 
        :class="svgClass"
    >
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />
    </svg>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps(['strokeColor', 'strokeWidth', 'iconClass'])

const svgClass = computed(() => {
    return props.iconClass ? props.iconClass : "h-4 w-4"
})

</script>